import React, { useState, useEffect } from 'react';
import { Box, TextField, Stack, Paper, Typography } from '@mui/material';

const parseItemIds = (raw) =>
  raw
    .split(/[\n,]/)
    .map((s) => s.trim())
    .filter(Boolean);

const ParamsKalshiV1 = ({ onParamsChange }) => {
  const [itemIdsRaw, setItemIdsRaw] = useState('');
  const [betLimit, setBetLimit] = useState(10);

  useEffect(() => {
    const item_ids = parseItemIds(itemIdsRaw);
    onParamsChange(
      item_ids.length > 0
        ? { item_ids, bet_limit: parseInt(betLimit, 10) || 10 }
        : null
    );
  }, [itemIdsRaw, betLimit, onParamsChange]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Paper sx={{ p: 2 }}>
        <Stack spacing={2}>
          <Typography variant="caption" color="text.secondary">
            Pass Kalshi market_ids (one per line or comma-separated). These match the <code>_id</code> values
            returned by <code>/search/filter_and_sort</code> on <code>kalshi-items</code>.
          </Typography>
          <TextField
            label="Market IDs"
            placeholder={'APPLEUS-29DEC31\nKXBTC-26DEC31'}
            value={itemIdsRaw}
            onChange={(e) => setItemIdsRaw(e.target.value)}
            multiline
            minRows={4}
            fullWidth
            size="small"
            variant="outlined"
          />
          <TextField
            label="Bets per market"
            type="number"
            value={betLimit}
            onChange={(e) => setBetLimit(e.target.value)}
            fullWidth
            size="small"
            variant="outlined"
            inputProps={{ min: 1, max: 100 }}
            helperText="Most recent bets returned per market (default 10)."
          />
        </Stack>
      </Paper>
    </Box>
  );
};

export default ParamsKalshiV1;
